module.exports = __webpack_public_path__ + "media/images/cards/cc-visa-f5dcfb25126be04020a4f16911eb6c9e.svg";